import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-277984b6")

_pushScopeId("data-v-277984b6")
const _hoisted_1 = { class: "custom-money-dialog-view-root" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", null, "自定义筹码", -1)
const _hoisted_4 = { class: "dialog-body" }
const _hoisted_5 = { class: "dialog-footer" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: ["dialog-content", { desktop: _ctx.device.display !== 1 }],
      onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
    }, [
      _createVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode("span", {
          class: "icon-close",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeDialog && _ctx.closeDialog(...args)))
        })
      ]),
      _createVNode("div", _hoisted_4, [
        _withDirectives(_createVNode("input", {
          placeholder: "自定义筹码",
          type: "number",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.chipValue = $event)),
          maxlength: "6",
          onKeydown: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.checkBuyinLength && _ctx.checkBuyinLength(...args)))
        }, null, 544), [
          [
            _vModelText,
            _ctx.chipValue,
            void 0,
            { number: true }
          ]
        ])
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode("button", {
          class: "confirm",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args)))
        }, "确 认"),
        _createVNode("button", {
          class: "cancel",
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.closeDialog && _ctx.closeDialog(...args)))
        }, "取消")
      ])
    ], 2)
  ]))
})